import ajax from "../assets/uilt/ajax";

let transactionDetails = {
  /**根据身份证+手机号获取交易记录 */
  getByPhoneAndIdCard: (req) => {
    return ajax.get({
      url: "/back/transaction-details/get-by-phone-and-idCard",
      param: req.param,
      success: req.success,
    });
  },
};

export default transactionDetails;
